<h2 mat-dialog-title>
  <mat-icon class="dialog-title-icon">group</mat-icon>
  Manage Users — {{ data.vendor.name }}
</h2>

<mat-dialog-content>
  <div class="dialog-container" appUserManual [userManualKey]="'manage-users-dialog'">

    <!-- Current / staged users -->
    <div class="assigned-section">
      <h4 class="section-label">Assigned Users ({{ mappedUsers.length }})</h4>
      <div class="user-chips" *ngIf="mappedUsers.length; else noUsers">
        <div class="user-chip" *ngFor="let user of mappedUsers" [class.newly-added]="isNewlyAdded(user)">
          <span class="user-chip-avatar">{{ getInitials(user) }}</span>
          <div class="user-chip-info">
            <span class="user-chip-name">{{ user.name || user.userName }}</span>
            <span class="user-chip-meta">{{ user.userName }}</span>
          </div>
          <button mat-icon-button class="user-chip-remove" (click)="removeUser(user)" matTooltip="Remove user">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <ng-template #noUsers>
        <div class="empty-state">
          <mat-icon>person_off</mat-icon>
          <span>No users assigned to this vendor</span>
        </div>
      </ng-template>
    </div>

    <!-- Add users -->
    <div class="add-section">
      <h4 class="section-label">Add Users</h4>
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search users to add</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput
               [formControl]="unmappedSearchControl"
               placeholder="Type at least 2 characters..." />
        <button *ngIf="unmappedSearchControl.value" mat-icon-button matSuffix (click)="unmappedSearchControl.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <div class="search-results" *ngIf="searchActive">
        <div class="available-user" *ngFor="let user of filteredUnmappedUsers" (click)="addUser(user)" (keydown.enter)="addUser(user)" tabindex="0" role="button">
          <span class="user-option-avatar small">{{ getInitials(user) }}</span>
          <div class="user-option-details">
            <span class="user-option-name">{{ user.name || user.userName }}</span>
            <span class="user-option-meta">{{ user.userName }}</span>
          </div>
          <mat-icon class="add-icon">add_circle_outline</mat-icon>
        </div>
        <div class="no-results" *ngIf="filteredUnmappedUsers.length === 0">
          <em>No matching users found</em>
        </div>
      </div>
      <div class="search-hint" *ngIf="!searchActive">
        <span>Type at least 2 characters to search</span>
      </div>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!hasChanges()">
    <mat-icon>save</mat-icon>
    Save Changes
  </button>
</mat-dialog-actions>
